import React from 'react';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Formsy from 'formsy-react';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from 'material-ui/IconButton';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import TextField from 'material-ui/TextField';
import $ from 'jquery';

import ExpansionPanel, {
    ExpansionPanelDetails,
    ExpansionPanelSummary,
} from 'material-ui/ExpansionPanel';
import Typography from 'material-ui/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Button, FormControlLabel, MenuItem, Radio, Paper, Chip, Icon } from 'material-ui';
import axios from 'axios';
import { withAlert } from 'react-alert';
import Downshift from 'downshift';
import keycode from 'keycode';
import Select from 'react-select';


import IntegrationAutosuggest from '../../extenalComponents/IntegrationAutosuggest';
// import config from '../../hrConfigs'

const styles = theme => ({
    layoutRoot: {},

    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    container: {
        flexGrow: 1,
        position: 'relative',
        height: 50,
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
});



let employeeData = []; //{name: 'Sheyan'}

var suggestions = [];
var olGradeArray = [];
var olSubjectArray = [];
var alGradeArray = [];
var alSubjectArray = [];
var inputsAddOGrades = [];
var inputsAddAGrades = [];

function renderInput(inputProps) {
    const { classes, ref, ...other } = inputProps;

    return (
        <TextField
            fullWidth
            InputProps={{
                inputRef: ref,
                classes: {
                    input: classes.input,
                },
                ...other,
            }}
        />
    );
}

function renderSuggestions(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion.label, query);
    const parts = parse(suggestion.label, matches);

    return (
        <MenuItem className="popup-value-size" selected={isHighlighted} component="div">
            <div>
                {parts.map((part, index) => {
                    return part.highlight ? (
                        <span key={String(index)} style={{ fontWeight: 300 }}>
                            {part.text}
                        </span>
                    ) : (
                            <strong key={String(index)} style={{ fontWeight: 500 }}>
                                {part.text}
                            </strong>
                        );
                })}
            </div>
        </MenuItem>
    );
}

function renderSuggestionsContainer(options) {
    const { containerProps, children } = options;

    return (
        <Paper {...containerProps} square>
            {children}
        </Paper>
    );
}

function getSuggestions(value) {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    let count = 0;

    return inputLength === 0
        ? []
        : suggestions.filter(suggestion => {
            const keep =
                count < 5 && suggestion.label.toLowerCase().slice(0, inputLength) === inputValue;

            if (keep) {
                count += 1;
            }

            return keep;
        });
}



// function renderInput(inputProps) {
//     const { InputProps, classes, ref, ...other } = inputProps;

//     return (
//         <TextField
//             InputProps={{
//                 inputRef: ref,
//                 classes: {
//                     root: classes.inputRoot,
//                 },
//                 ...InputProps,
//             }}
//             {...other}
//         />
//     );
// }

// function renderSuggestion({ suggestion, index, itemProps, highlightedIndex, selectedItem }) {
//     const isHighlighted = highlightedIndex === index;
//     const isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;

//     return (
//         <MenuItem
//             {...itemProps}
//             key={suggestion.label}
//             selected={isHighlighted}
//             component="div"
//             style={{
//                 fontWeight: isSelected ? 500 : 400,
//             }}
//         >
//             {suggestion.label}
//         </MenuItem>
//     );
// }
// renderSuggestion.propTypes = {
//     highlightedIndex: PropTypes.number,
//     index: PropTypes.number,
//     itemProps: PropTypes.object,
//     selectedItem: PropTypes.string,
//     suggestion: PropTypes.shape({ label: PropTypes.string }).isRequired,
// };



class Tab2EducationQualification extends React.Component {
    state = {
        value: 0,
    };

    constructor(props) {
        super(props);
        this.state = {
            imageURL: 'assets/images/default-avatar.png',
            value: '',
            nic: '',
            expanded: 'panel1',
            emp_profile_id: '',
            oCountry: '',
            aCountry: '',
            oGrade: '',
            oSubject: '',
            aGrade: '',
            aSubject: '',
            inputsAddOGrades: [],
            olGradeArray: [],
            olSubjectArray: [],
            inputsAddAGrades: [],
            alGradeArray: [],
            alSubjectArray: [],
            studyCountry: '',
            emp_registry_id: '',
            inputsAddOGrade: ['1'],
            inputsAddAGrade: ['1'],
            suggestions: [],
            loadCountryList: [],
            emp: {
                ref_no: '',
                epf_no: '',
                firstName: '',
                middleName: '',
                lastName: '',
            }
        };
        this.getSuggestionValue = this.getSuggestionValue.bind(this);
        // this.publish = this.publish.bind(this);

        this.loadAllCountries();
        this.setState({ expanded: 'panel1' });
        // this.handleChangeNic = this.handleChangeNic.bind(this);

        // this.getEmployeeDetails();

    }
    loadAllCountries() {
        var loadCountryList = [];

        axios.get('https://restcountries.eu/rest/v2/all')
            .then(response => {
                // console.log();
                for (let i = 0; i < response.data.length; i++) {

                    loadCountryList.push({
                        value: response.data[i].name,
                        label: response.data[i].name
                    });
                }

            }).catch(function (error) {
                console.log("err " + error);
                // alert("No internet connection or Internal error");
            });
        var c = { country: loadCountryList };

        return c;
    }



    handleOCountryChange = (selectedOption) => {
        // alert(selectedOption.value)
        this.setState({ oCountry: selectedOption });

    }
    handleACountryChange = (selectedOption) => {
        // alert(selectedOption.value)
        this.setState({ aCountry: selectedOption });
    }
    handleStudyCountryChange = (selectedOption) => {
        // alert(selectedOption.value)
        this.setState({ studyCountry: selectedOption });
    }

    getSuggestionValue(suggestion) {
        var userProfileObj = {
            nic: suggestion.label
        }
        // alert(config.server.host)
        // axios.post('http://localhost:5002/hr/loadEmpDetailsByNic', userProfileObj)
        axios.post(window.hrmServer+'/hr/loadEmpDetailsByNic', userProfileObj)
            .then(response => {
                if (response.data.success) {
                    // alert('Success'+response.data.result[0].DESIGNATION);
                    var designationObj = response.data.result;
                    // var img = 'http://localhost:3000/' + designationObj[0].PROFILE_IMAGE
                    // var img = 'http://192.169.143.105:3006/' + designationObj[0].PROFILE_IMAGE
                    var img = designationObj[0].PROFILE_IMAGE
                }
                this.setState({
                    imageURL: img,
                    emp: {
                        ref_no: designationObj[0].REF_NO,
                        epf_no: designationObj[0].EPF_CPF,
                        firstName: designationObj[0].FIRST_NAME,
                        middleName: designationObj[0].MIDDLE_NAME,
                        lastName: designationObj[0].LAST_NAME
                    },
                    nic: designationObj[0].NIC,
                    emp_profile_id: designationObj[0].ID_EMPLOYEE_PROFILE,
                    emp_registry_id: designationObj[0].ID_EMPLOYEE_REGISTRY,


                });
                this.props.nicpasser(designationObj[0].NIC,
                    designationObj[0].ID_EMPLOYEE_PROFILE,
                    designationObj[0].ID_EMPLOYEE_REGISTRY);

            }).catch(function (error) {
                console.log("err " + error);
                // alert("No internet connection or Internal error");
            });
        return suggestion.label;
    }

    handleSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: getSuggestions(value),
        });
    };

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    handleChanges = (event, { newValue }) => {
        // alert(newValue)
        this.setState({
            value: newValue,
        });
        this.loadSearchNIC(newValue)
    };



    // selectChange = (event, { value }) => {
    //     alert(value)
    //     // this.setState({
    //     //     value: newValue,
    //     // });

    // };

    clearValue = () => {
        this.form.reset();
        this.setState({
            value: '',
            oGrade:'',
            oSubject:'',
            aGrade:'',
            aSubject:'',
            inputsAddOGrades: [],
            inputsAddAGrades: [],
            oCountry: '',
            aCountry: ''
        });
    }

    //nic change
    // handleChangeNic(event) {
    //     // alert(event.target.value)
    //     this.setState({ value: event.target.value });

    // }
    handleChangeOSubject = (e) => {
        // alert(e.target.value)
        this.setState({ oSubject: e.target.value });
    }

    handleChangeOGrade = (e) => {
        // alert(e.target.value)
        this.setState({ oGrade: e.target.value });
    }

    handleChangeASubject = (e) => {
        // alert(e.target.value)
        this.setState({ aSubject: e.target.value });
    }

    handleChangeAGrade = (e) => {
        // alert(e.target.value)
        this.setState({ aGrade: e.target.value });
    }

    deleteOResult(grade, subject) {
        // alert(grade+""+subject)
        var arrayOGrade = this.state.olGradeArray // make a separate copy of the array
        // alert("-1- " + arrayOGrade)
        var index = arrayOGrade.indexOf(grade)
        // alert("-index- " + index)
        arrayOGrade.splice(index, 1);
        // alert(arrayGrade)

        var arrayOSubject = this.state.olSubjectArray // make a separate copy of the array
        // alert(e+"-- "+arrayGrade)
        var index = arrayOSubject.indexOf(subject)
        arrayOSubject.splice(index, 1);
        // alert("-2- " + arrayOGrade)

        var newInputAdd = `${this.state.inputsAddOGrade.length - 1}`

        this.setState({
            inputsAddOGrade: this.state.inputsAddOGrade.concat([newInputAdd]),
            olGradeArray: arrayOGrade,
            olSubjectArray: arrayOSubject

        });
        // alert("-3- "+this.state.olGradeArray)
        this.removeOGrade();
        // this.setState({ people: array });
    }

    removeOGrade() {

        inputsAddOGrades = [];
        this.setState({
            inputsAddOGrades: [],
        });
        // alert("-3- " + this.state.olGradeArray)

        for (let i = 0; i < this.state.olGradeArray.length; i++) {
            inputsAddOGrades.push(
                <div className="w-full">
                    <TextFieldFormsy
                        className="w-full md:w-1/3 mt-16 pr-24"
                        id={"oSubject" + i}
                        type="text"
                        name={"oSubject" + i}
                        label={"Subject"}
                        disabled={true}
                        value={this.state.olSubjectArray[i]}
                        validations={{
                            maxLength: 50
                        }}
                        validationErrors={{

                            maxLength: 'This is not a valid'
                        }}
                    />

                    <TextFieldFormsy
                        className="w-full md:w-1/3 mt-16 pr-24"
                        id={"oGreade" + i}
                        type="text"
                        name={"oGreade" + i}
                        label={"Greade"}
                        disabled={true}
                        value={this.state.olGradeArray[i]}
                        validations={{
                            maxLength: 50
                        }}
                        validationErrors={{

                            maxLength: 'This is not a valid'
                        }}
                    />


                    <IconButton style={{ marginLeft: 'auto', height: '38px' }}
                        title="Delete or Restore"
                        // className={classes.smaller}
                        onClick={(ev) => {
                            // ev.stopPropagation();
                            this.deleteOResult(this.state.olGradeArray[i], this.state.olSubjectArray[i])
                        }}

                    >
                        <Icon className="text-red-light">delete</Icon>
                    </IconButton>

                    {/* <div>
                        <Button type="button" variant="fab" mini color="secondary" onClick={() => this.appendInputOGrade()} aria-label="add">
                            <AddIcon />
                        </Button>
                    </div> */}

                </div>

            )
        }
        this.setState({
            inputsAddOGrades: inputsAddOGrades,
        });
    }

    // publish({ target }) {
    //     alert(target.grade)
        
    //   }

    deleteAResult(grade, subject) {
        // alert(grade+"------------"+subject)
        var arrayAGrade = this.state.alGradeArray // make a separate copy of the array
        // alert("-1- " + arrayAGrade)
        var index = arrayAGrade.indexOf(grade)
        // alert("-index- " + index)
        arrayAGrade.splice(index, 1);
        // alert(arrayAGrade)

        var arrayASubject = this.state.alSubjectArray // make a separate copy of the array
        // alert(e+"-- "+arrayGrade)
        var index = arrayASubject.indexOf(subject)
        arrayASubject.splice(index, 1);
        // alert("-2- " + arrayAGrade)

        var newInputAdd = `${this.state.inputsAddAGrade.length - 1}`

        this.setState({
            inputsAddAGrade: this.state.inputsAddAGrade.concat([newInputAdd]),
            alGradeArray: arrayAGrade,
            alSubjectArray: arrayASubject

        });
        // alert("-3- "+this.state.olGradeArray)
        this.removeAGrade();
        // this.setState({ people: array });
    }

    removeAGrade() {

        inputsAddAGrades = [];
        this.setState({
            inputsAddAGrades: [],
        });
        // alert("-3- " + this.state.alGradeArray)

        for (let j = 0; j < this.state.alGradeArray.length; j++) {

            // alert(j+"-4- " + this.state.alSubjectArray[j])
            inputsAddAGrades.push(
                <div className="w-full">
                    <TextFieldFormsy
                        className="w-full md:w-1/3 mt-16 pr-24"
                        id={"aSubject" + j}
                        type="text"
                        name={"aSubject" + j}
                        label={"Subject"}
                        disabled={true}
                        value={this.state.alSubjectArray[j]}
                        validations={{
                            maxLength: 50
                        }}
                        validationErrors={{

                            maxLength: 'This is not a valid'
                        }}
                    />

                    <TextFieldFormsy
                        className="w-full md:w-1/3 mt-16 pr-24"
                        id={"aGreade" + j}
                        type="text"
                        name={"aGreade" + j}
                        label={"Greade"}
                        disabled={true}
                        value={this.state.alGradeArray[j]}
                        validations={{
                            maxLength: 50
                        }}
                        validationErrors={{

                            maxLength: 'This is not a valid'
                        }}
                    />


                    <IconButton style={{ marginLeft: 'auto', height: '38px' } }
                        title="Delete or Restore"
                        grade = {this.state.alGradeArray[j]}
                        subject = {this.state.alSubjectArray[j]}
                        // className={classes.smaller}
                        onClick={() => this.deleteAResult(this.state.alGradeArray[j], this.state.alSubjectArray[j])}
                        // onClick={ this.publish }
                    >
                        <Icon className="text-red-light">delete</Icon>
                    </IconButton>

                    {/* <div>
                        <Button type="button" variant="fab" mini color="secondary" onClick={() => this.appendInputOGrade()} aria-label="add">
                            <AddIcon />
                        </Button>
                    </div> */}

                </div>

            )
        }
        this.setState({
            inputsAddAGrades: inputsAddAGrades,
        });
    }

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false
            // value: event.target.value
        });
    };

    handleClick = () => {
        this.setState({
            value: 'Sheyan',
        });
    };

    appendInputOGrade() {
        // alert("a")
        // var newInputAdd = `${this.state.inputsAddOGrade.length + 1}`;
        var newInputAdd = `${this.state.inputsAddOGrade.length}`;

        var valueOfLastAddOGrade = this.state.oGrade;
        var valueOfLastAddOSubject = this.state.oSubject;

        if ("" == valueOfLastAddOGrade || null == valueOfLastAddOGrade || undefined == valueOfLastAddOGrade ||
            "" == valueOfLastAddOSubject || null == valueOfLastAddOSubject || undefined == valueOfLastAddOSubject) {
            this.props.alert.info("Add Subject And Grade First !");
        } else {
            // this.setState({
            // inputsAddOGrade: this.state.inputsAddOGrade.concat([newInputAdd])
            // ,
            // olGradeArray: olGradeArray,
            // olSubjectArray: olSubjectArray
            // });
            this.appendInputOGrades(this.state.oGrade, this.state.oSubject)

            this.setState({
                oGrade: '',
                oSubject: ''
            });
        }
    }


    appendInputOGrades(a, b) {
        // alert(length+"vv"+a+"vv"+b)
        // var newInputAdd = `${this.state.inputsAddOGrade.length + 1}`;

        var newInputAdd = `${this.state.inputsAddOGrade.length}`;

        olGradeArray.push(a)
        olSubjectArray.push(b)


        inputsAddOGrades.push(
            <div className="w-full">

                <TextFieldFormsy
                    className="w-full md:w-1/3 mt-16 pr-24"
                    id={"oSubject" + newInputAdd}
                    type="text"
                    name={"oSubject" + newInputAdd}
                    label={"Subject"}
                    disabled={true}
                    value={b}
                    validations={{
                        maxLength: 50
                    }}
                    validationErrors={{

                        maxLength: 'This is not a valid'
                    }}
                />

                <TextFieldFormsy
                    className="w-full md:w-1/3 mt-16 pr-24"
                    id={"oGreade" + newInputAdd}
                    type="text"
                    name={"oGreade" + newInputAdd}
                    label={"Greade"}
                    disabled={true}
                    value={a}
                    validations={{
                        maxLength: 50
                    }}
                    validationErrors={{

                        maxLength: 'This is not a valid'
                    }}
                />


                <IconButton style={{ marginLeft: 'auto', height: '38px' }}
                    title="Delete or Restore"
                    // className={classes.smaller}
                    onClick={(ev) => {
                        // ev.stopPropagation();
                        this.deleteOResult(a, b)
                    }}

                >
                    <Icon className="text-red-light">delete</Icon>
                </IconButton>

                {/* <div>
                    <Button type="button" variant="fab" mini color="secondary" onClick={() => this.appendInputOGrade()} aria-label="add">
                        <AddIcon />
                    </Button>
                </div> */}

            </div>

        )

        // alert(length + "vv" + a + "vv" + b)
        this.setState({
            inputsAddOGrade: this.state.inputsAddOGrade.concat([newInputAdd]),
            inputsAddOGrades: inputsAddOGrades,
            olGradeArray: olGradeArray,
            olSubjectArray: olSubjectArray

        });
        // alert(this.state.olSubjectArray.length)
        // this.setState({ edit: true });


    }


    appendInputAGrade() {
        //alert("a")
        var newInputAdd = `${this.state.inputsAddAGrade.length + 1}`;

        var valueOfLastAddGrade = this.state.aGrade;
        var valueOfLastAddSubject = this.state.aSubject;

        if ("" == valueOfLastAddGrade || null == valueOfLastAddGrade || undefined == valueOfLastAddGrade ||
            "" == valueOfLastAddSubject || null == valueOfLastAddSubject || undefined == valueOfLastAddSubject) {
            this.props.alert.info("Add Subject And Grade First !");
        } else {
            // this.setState({ inputsAddAGrade: this.state.inputsAddAGrade.concat([newInputAdd]) });
            this.appendInputAGrades(this.state.aGrade, this.state.aSubject)

            this.setState({
                aGrade: '',
                aSubject: ''
            });
        }
    }


    appendInputAGrades(a, b) {
        // alert(length+"vv"+a+"vv"+b)
        // var newInputAdd = `${this.state.inputsAddOGrade.length + 1}`;

        var newInputAdd = `${this.state.inputsAddAGrade.length}`;

        alGradeArray.push(a)
        alSubjectArray.push(b)


        inputsAddAGrades.push(
            <div className="w-full">

                <TextFieldFormsy
                    className="w-full md:w-1/3 mt-16 pr-24"
                    id={"aSubject" + newInputAdd}
                    type="text"
                    name={"aSubject" + newInputAdd}
                    label={"Subject"}
                    disabled={true}
                    value={b}
                    validations={{
                        maxLength: 50
                    }}
                    validationErrors={{

                        maxLength: 'This is not a valid'
                    }}
                />

                <TextFieldFormsy
                    className="w-full md:w-1/3 mt-16 pr-24"
                    id={"aGreade" + newInputAdd}
                    type="text"
                    name={"aGreade" + newInputAdd}
                    label={"Greade"}
                    disabled={true}
                    value={a}
                    validations={{
                        maxLength: 50
                    }}
                    validationErrors={{

                        maxLength: 'This is not a valid'
                    }}
                />


                <IconButton style={{ marginLeft: 'auto', height: '38px' }}
                    title="Delete or Restore"
                    // className={classes.smaller}
                    onClick={(ev) => {
                        // ev.stopPropagation();
                        this.deleteAResult(a, b)
                    }}

                >
                    <Icon className="text-red-light">delete</Icon>
                </IconButton>

                {/* <div>
                    <Button type="button" variant="fab" mini color="secondary" onClick={() => this.appendInputOGrade()} aria-label="add">
                        <AddIcon />
                    </Button>
                </div> */}

            </div>

        )

        // alert(length + "vv" + a + "vv" + b)
        this.setState({
            inputsAddAGrade: this.state.inputsAddAGrade.concat([newInputAdd]),
            inputsAddAGrades: inputsAddAGrades,
            alGradeArray: alGradeArray,
            alSubjectArray: alSubjectArray

        });
        // alert(this.state.olSubjectArray.length)
        // this.setState({ edit: true });


    }


    searchEmployeeViaNIC(e) {
        e.preventDefault();

        var nic = $("#searchNicNo").val();

        // axios.post('http://localhost:5002/searchEmployee', {
        axios.post(window.hrmServer+'/searchEmployee', {
            saerchVal: nic
        })
            .then(function (response) {

                if (response.data.success) {
                    // alert("success");
                    var employeeDetailObj = response.data.result;

                    alert(employeeDetailObj[0].NIC);
                    this.setState({
                        value: employeeDetailObj[0].NIC,
                    });

                    // $('#searchRefNo').val(employeeDetailObj[0].REF_NO);
                    // $('#searchEpfNo').val(employeeDetailObj[0].EPF_CPF);
                } else {
                    alert("success ER");
                }
            })
            .catch(function (error) {
                console.log(error);
                alert("error");
            });
    }

    //nic search
    loadSearchNIC(value) {
        var userProfileObj = {
            searchVal: value
        }
        // axios.post('http://localhost:5002/hr/searchEmployeeByNic', userProfileObj)
        axios.post(window.hrmServer+'/hr/searchEmployeeByNic', userProfileObj)
            .then(response => {
                if (response.data.success) {
                    // alert('Success'+response.data.result[0].DESIGNATION);
                    var designationObj = response.data.result;
                    // console.log("peeen "+employeeObj[31].PROFILE_IMAGE);
                    suggestions = [];
                    for (var i = 0; i < designationObj.length; i++) {

                        suggestions.push({
                            label: designationObj[i].NIC
                        });
                    }
                    this.setState({ suggestions: suggestions });
                }


            }).catch(function (error) {
                console.log("err " + error);
                // alert("No internet connection or Internal error");
            });
    }

    //loadEmployeeDetailsByNic
    // loadEmpDetailsByNic(value) {
    //     var userProfileObj = {
    //         nic: value
    //     }
    //     axios.post('http://localhost:5002/hr/loadEmpDetailsByNic', userProfileObj)
    //         .then(response => {
    //             if (response.data.success) {
    //                 // alert('Success'+response.data.result[0].DESIGNATION);
    //                 var designationObj = response.data.result;
    //                 // console.log("peeen "+employeeObj[31].PROFILE_IMAGE);
    //                 suggestions = [];
    //                 // for (var i = 0; i < designationObj.length; i++) {

    //                     // suggestions.push({
    //                     //     label: designationObj.NIC
    //                     // });
    //                 // }
    //             }
    //             this.setState({ imageURL: designationObj.PROFILE_IMAGE });

    //         }).catch(function (error) {
    //             console.log("err " + error);
    //             // alert("No internet connection or Internal error");
    //         });
    // }


    saveEmployeeQulifiation(model) {
        // alert(model.studyenddate)
        // add to array all deduction types and values 

        // for (var i = 1; i < (this.state.inputsAddAGrade.length + 1); i++) {

        //     var alSubject = model['aSubject' + i];
        //     var alGrade = model['aGreade' + i];
        //     alSubjectArray.push(alSubject);
        //     alGradeArray.push(alGrade);
        // }

        // add to array all addtion types and values 
        // for (var j = 1; j < (this.state.inputsAddOGrade.length + 1); j++) {
        //     var olSubject = model['oSubject' + j];
        //     var olGrade = model['oGreade' + j];
        //     olSubjectArray.push(olSubject);
        //     olGradeArray.push(olGrade);
        // }

        const employeeEducationDataObj = {
            nic: this.state.nic,
            emp_profile_id: this.state.emp_profile_id,
            emp_registry_id: this.state.emp_registry_id,
            oSchool: model.oSchool,
            oCountry: this.state.oCountry.value,
            oYear: model.oYear,
            oIndexNo: model.oIndexNo,
            aSchool: model.aSchool,
            aCountry: this.state.aCountry.value,
            aYear: model.aYear,
            aIndexNo: model.aIndexNo,
            instrituteUnivercity: model.instrituteUnivercity,
            degreeCertificate: model.degreeCertificate,
            degreeCertificateLevel: model.degreeCertificateLevel,
            fieldStudy: model.fieldStudy,
            studyCountry: this.state.studyCountry.value,
            studyStatus: model.studyStatus,
            studyStartDate: model.studystartdate,
            studyEndDate: model.studyenddate,

            alSubjectArray: this.state.alSubjectArray,
            alGradeArray: this.state.alGradeArray,

            olGradeArray: this.state.olGradeArray,
            olSubjectArray: this.state.olSubjectArray

        }
        console.log(employeeEducationDataObj)

        var strtDt = new Date(model.studystartdate);
        var endDt = new Date(model.studyenddate);
        var flag = 0; // false



        if (endDt.getTime() <= strtDt.getTime()) {
            this.props.alert.error("end date Can't be less than start date");
        } else {
            // axios.post('http://localhost:5002/hr/saveEmpQulification', employeeEducationDataObj)
            axios.post(window.hrmServer+'/hr/saveEmpQulification', employeeEducationDataObj)
                .then(res => {

                    // alert(res.data.success);
                    if (res.data.success) {
                        this.form.reset();
                        this.setState({
                            oCountry: '',
                            aCountry: '',
                            studyCountry: '',
                            inputsAddOGrade: ['1'],
                            inputsAddOGrades: [],
                            olGradeArray: [],
                            olSubjectArray: [],
                            inputsAddAGrade: ['1'],
                            inputsAddAGrades: [],
                            alGradeArray: [],
                            alSubjectArray: []
                        });
                        // alert(this.state.inputsAddOGrades)
                        inputsAddOGrades = [];
                        olGradeArray = [];
                        olSubjectArray = [];
                        inputsAddAGrades = [];
                        alGradeArray = [];
                        alSubjectArray = [];
                        this.props.alert.success("Employee Education Qulification Added Successfully.");

                        // alert("Success");
                        // employeeInsertId = res.data.empId;

                    } else {
                        // alert('Ivalid Credentials');
                        this.props.alert.error("Error In Employee Education Qulification Adding.");
                    }
                })
        }

    }

    onSubmit = (model) => {


        if ("" == this.state.emp_profile_id || null == this.state.emp_profile_id || undefined == this.state.emp_profile_id ||
            "" == this.state.emp_registry_id || null == this.state.emp_registry_id || undefined == this.state.emp_registry_id) {
            this.props.alert.error("You have To Add Employee Details First.");
        } else {
            this.saveEmployeeQulifiation(model);
            // alert("onsubmit");
        }

    };


    render() {
        const { classes } = this.props;
        const { expanded } = this.state;
        const { inputValue, selectedItem } = this.state;
        // const { classes } = this.props;

        // Autosuggest will pass through all these props to the input.
        // const inputProps = {
        //     placeholder: 'Type a programming language',
        //     value,
        //     onChange: this.onChange
        // };

        return (
            <div className="{classes.root} mt-16">
                <Formsy
                    onValidSubmit={this.onSubmit}
                    onValid={this.enableButton}
                    onInvalid={this.disableButton}
                    ref={(form) => this.form = form}
                    className="flex flex-col justify-center"
                >

                    <ExpansionPanel expanded={expanded === 'panel1'} onChange={this.handleChange('panel1')}>
                        <ExpansionPanelSummary className="emp-reg-expand-color-1" expandIcon={<ExpandMoreIcon />}>
                            <Typography className="{classes.heading} flex flex-wrap">Personal Details</Typography>
                            {/* <Typography className={classes.secondaryHeading}>I am an expansion panel</Typography> */}
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Typography>
                                <div className="flex flex-wrap -mx-3 mb-6">

                                    <div className="w-full md:w-1/4  pr-24">
                                        <div className="MuiAvatar-root-915 w-80 h-80">
                                            <img id="profileImg" src={this.state.imageURL} className="w-80 h-80" />
                                        </div>
                                    </div>

                                    <div className="w-full md:w-1/4 mt-16 pr-24">
                                        <Autosuggest
                                            // className="w-full pt-8"
                                            theme={{
                                                container: classes.container,
                                                suggestionsContainerOpen: classes.suggestionsContainerOpen,
                                                suggestionsList: classes.suggestionsList,
                                                suggestion: classes.suggestion,
                                            }}
                                            renderInputComponent={renderInput}
                                            suggestions={this.state.suggestions}
                                            onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                                            onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
                                            renderSuggestionsContainer={renderSuggestionsContainer}
                                            getSuggestionValue={this.getSuggestionValue}
                                            renderSuggestion={renderSuggestions}

                                            inputProps={{
                                                classes,
                                                placeholder: 'Search NIC',
                                                value: this.state.value,
                                                onChange: this.handleChanges,
                                                // onSelect:this.selectChange,
                                                // onKeyPress : this.handleChanges,
                                            }}

                                        />

                                    </div>

                                    <div className="w-full md:w-1/4 -mt-2 pr-24">


                                        {/* <DownshiftMultiple placeholder={{ph:'EPF No', id: 'epfNoSearch'}} /> */}
                                        <TextFieldFormsy
                                            ref="searchRefNo"
                                            className="w-full"
                                            type="text"
                                            name="searchRefNo"
                                            label="Ref.No"
                                            disabled={true}
                                            validations={{
                                                maxLength: 50
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid '
                                            }}
                                            value={this.state.emp.ref_no}


                                        />
                                    </div>

                                    <div className="w-full md:w-1/4 -mt-2 pr-24">
                                        {/* <DownshiftMultiple placeholder={{ph:'EPF No', id: 'epfNoSearch'}} /> */}
                                        <TextFieldFormsy
                                            id="searchEpfNox    "
                                            className="w-full"
                                            type="text"
                                            name="searchEpfNo"
                                            label="EPF No"
                                            disabled={true}
                                            validations={{
                                                maxLength: 50
                                            }}
                                            validationErrors={{

                                                maxLength: 'This is not a valid '
                                            }}
                                            value={this.state.emp.epf_no}
                                        // disabled

                                        />
                                    </div>

                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 -mt-2 pr-24"
                                        type="text"
                                        name="lastName"
                                        label="Last Name"
                                        disabled={true}
                                        // validations={{
                                        //     required: ""
                                        // }}
                                        validationErrors={{
                                            minLength: 'Min character length is 4'
                                        }}
                                        validations={{
                                            maxLength: 150
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid r'
                                        }}
                                        required
                                        value={this.state.emp.lastName}
                                    />

                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 -mt-2  pr-24"
                                        type="text"
                                        name="firstName"
                                        label="First Name"
                                        disabled={true}
                                        // validations={{
                                        //     required: ""
                                        // }}
                                        validations={{
                                            maxLength: 150
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid '
                                        }}
                                        validationErrors={{
                                            minLength: 'Min character length is 4'
                                        }}
                                        required
                                        value={this.state.emp.firstName}
                                    />

                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 -mt-2  pr-24"
                                        type="text"
                                        name="middleName"
                                        label="Middle Name"
                                        validations={{
                                            maxLength: 150
                                        }}
                                        disabled={true}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                        value={this.state.emp.middleName}
                                    />
                                </div>
                            </Typography>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel expanded={expanded === 'panel2'} onChange={this.handleChange('panel2')}>
                        <ExpansionPanelSummary className="emp-reg-expand-color-2" expandIcon={<ExpandMoreIcon />}>
                            <Typography className="{classes.heading} flex flex-wrap">Ordinary Level / Middle School</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="flex flex-wrap -mx-3 mb-6">

                            <TextFieldFormsy
                                className="w-full mt-12 pr-24"
                                type="text"
                                name="oSchool"
                                label="School"
                                validations={{
                                    maxLength: 150
                                }}
                                validationErrors={{

                                    maxLength: 'This is not a valid'
                                }}
                                required
                            />



                            {/* <div className="w-full "> */}

                            {/* <div className="w-full"> */}
                            {/* <SelectFormsy
                                        className="w-full md:w-1/3  mt-16 pr-24"
                                        name="oCountry"
                                        label="Country"
                                        value="Sri Lanka"
                                        validations={{
                                            maxLength: 150
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid Country'
                                        }}
                                    >
                                        <MenuItem value="none">
                                            <em>None</em>

                                        </MenuItem>
                                        {this.state.loadCountryList.map(function (item, i) {
                                            return <MenuItem value={item.value}>{item.value}</MenuItem>;
                                        })}
                                        {/* <MenuItem value="daily">Daily</MenuItem>
                                        <MenuItem value="monthly">Monthly</MenuItem>
                                        <MenuItem value="yearly">Yearly</MenuItem>
                                        <MenuItem value="projectBase">Project Base</MenuItem> */}
                            {/* </SelectFormsy> */}

                            {/* <div className="w-full  mt-16 pr-24 inline-block"> */}

                            <Select
                                className="w-full md:w-1/3 pt-16 mt-16 pr-24 "
                                name="form-field-name"
                                placeholder="Search Country"
                                value={this.state.oCountry}
                                onChange={this.handleOCountryChange}
                                options={this.loadAllCountries().country}
                            />
                            {/* </div> */}



                            <TextFieldFormsy
                                className="w-full md:w-1/3 mt-16 pr-24"
                                type="text"
                                name="oYear"
                                label="Year"
                                validations={{
                                    maxLength: 150,
                                    isNumeric: true
                                }}
                                validationErrors={{
                                    maxLength: 'This is not a valid year',
                                    maxLength: 'This is not a valid year'
                                }}
                            />

                            <TextFieldFormsy
                                className="w-full md:w-1/3 mt-16 pr-24 "
                                type="text"
                                name="oIndexNo"
                                label="IndexNo"
                                validations={{
                                    maxLength: 150
                                }}
                                validationErrors={{

                                    maxLength: 'This is not a valid'
                                }}
                            />

                            {/* </div> */}
                            {/* </div> */}

                            <div id="divAllowanceAdd" className="w-full md:w-1/2">
                                {/* {this.state.inputsAddOGrade.map(inputAdd => */}
                                <div className="w-full">

                                    <TextField
                                        className="w-full md:w-2/3 mt-16 pr-24"
                                        id={"oSubject"}
                                        type="text"
                                        name={"oSubject"}
                                        label={"Subject "}
                                        value={this.state.oSubject}
                                        onChange={this.handleChangeOSubject}
                                        validations={{
                                            maxLength: 50
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />

                                    <TextField
                                        className="w-full md:w-1/3 mt-16 pr-24"
                                        id={"oGreade"}
                                        type="text"
                                        name={"oGreade"}
                                        label={"Grade "}
                                        value={this.state.oGrade}
                                        onChange={this.handleChangeOGrade}
                                        validations={{
                                            maxLength: 50
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />
                                </div>
                                {/* )} */}
                                {this.state.inputsAddOGrades}
                            </div>
                            <Button type="button" variant="fab" mini color="secondary" onClick={() => this.appendInputOGrade()} aria-label="add" className="{classes.button} mt-24">
                                <AddIcon />
                            </Button>

                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel expanded={expanded === 'panel3'} onChange={this.handleChange('panel3')}>
                        <ExpansionPanelSummary className="emp-reg-expand-color-3" expandIcon={<ExpandMoreIcon />}>

                            <Typography className="{classes.heading} flex flex-wrap">Advance Level / High School</Typography>

                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="flex flex-wrap -mx-3 mb-6">

                            <TextFieldFormsy
                                className="w-full pr-24"
                                type="text"
                                name="aSchool"
                                label="School"
                                required
                                validations={{
                                    maxLength: 150
                                }}
                                validationErrors={{

                                    maxLength: 'This is not a valid'
                                }}
                            />


                            {/* <div className="w-full"> */}
                            {/* <SelectFormsy
                                    className="w-full md:w-1/3  mt-16 pr-24"
                                    name="aCountry"
                                    label="Country"
                                    value="Sri Lanka"
                                    validations={{
                                        maxLength: 150
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}
                                >
                                    <MenuItem value="none">
                                        <em>None</em>

                                    </MenuItem>
                                    {this.state.loadCountryList.map(function (item, i) {
                                        return <MenuItem value={item.value}>{item.value}</MenuItem>;
                                    })}
                                </SelectFormsy> */}


                            {/* <Downshift >
                                {({ getInputProps, getItemProps, isOpen, inputValue, selectedItem, highlightedIndex }) => (
                                    <div className="w-full md:w-1/3  mt-36 pr-24">
                                        {renderInput({
                                            fullWidth: true,
                                            classes,
                                            InputProps: getInputProps({
                                                placeholder: 'Search Your country ',
                                                id: 'aCountry'

                                            }),
                                        })}
                                        {isOpen ? (
                                            <Paper className={classes.paper} square>
                                                {this.getSuggestions(inputValue).map((suggestion, index) =>
                                                    renderSuggestion({
                                                        suggestion,
                                                        index,
                                                        itemProps: getItemProps({ item: suggestion.label }),
                                                        highlightedIndex,
                                                        selectedItem,
                                                    }),
                                                )}
                                            </Paper>
                                        ) : null}
                                    </div>
                                )}
                            </Downshift> */}

                            <Select
                                className="w-full md:w-1/3 pt-16 mt-16 pr-24 "
                                name="form-field-name"
                                placeholder="Search Country"
                                value={this.state.aCountry}
                                onChange={this.handleACountryChange}
                                options={this.loadAllCountries().country}
                            />

                            <TextFieldFormsy
                                className="w-full md:w-1/3 mt-16 pr-24"
                                type="text"
                                name="aYear"
                                label="Year"
                                validations={{
                                    maxLength: 150,
                                    isNumeric: true
                                }}
                                validationErrors={{
                                    maxLength: 'This is not a valid year',
                                    maxLength: 'This is not a valid year'
                                }}
                            />

                            <TextFieldFormsy
                                className="w-full md:w-1/3 mt-16 pr-24"
                                type="text"
                                name="aIndexNo"
                                label="IndexNo"
                                validations={{
                                    maxLength: 150
                                }}
                                validationErrors={{

                                    maxLength: 'This is not a valid'
                                }}
                            />

                            {/* </div> */}


                            <div id="divAllowanceAdd" className="w-full md:w-1/2">
                                {/* {this.state.inputsAddAGrade.map(inputAdd => */}
                                <div className="w-full">

                                    <TextField
                                        className="w-full md:w-2/3 mt-16 pr-24"
                                        id={"aSubject"}
                                        type="text"
                                        name={"aSubject"}
                                        label={"Subject "}
                                        value={this.state.aSubject}
                                        onChange={this.handleChangeASubject}
                                        validations={{
                                            maxLength: 150
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />

                                    <TextField
                                        className="w-full md:w-1/3 mt-16 pr-24"
                                        id={"aGreade"}
                                        type="text"
                                        name={"aGreade"}
                                        label={"Grade "}
                                        value={this.state.aGrade}
                                        onChange={this.handleChangeAGrade}
                                        validations={{
                                            maxLength: 150
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />
                                </div>
                                {/* )} */}
                                {this.state.inputsAddAGrades}
                            </div>
                            <Button type="button" variant="fab" onClick={() => this.appendInputAGrade()} mini color="secondary" aria-label="add" className="{classes.button} mt-24">
                                <AddIcon />
                            </Button>

                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel expanded={expanded === 'panel4'} onChange={this.handleChange('panel4')}>
                        <ExpansionPanelSummary className="emp-reg-expand-color-4" expandIcon={<ExpandMoreIcon />}>

                            <Typography className="{classes.heading} flex flex-wrap">High Education</Typography>

                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="flex flex-wrap -mx-3 mb-6">
                            <TextFieldFormsy
                                className="w-full pr-24"
                                type="text"
                                name="instrituteUnivercity"
                                label="Institute / University"
                                required
                                validations={{
                                    maxLength: 150
                                }}
                                validationErrors={{

                                    maxLength: 'This is not a valid'
                                }}
                            />

                            <div className="w-full">
                                <SelectFormsy
                                    className="w-full md:w-1/3  mt-16 pr-24"
                                    name="degreeCertificate"
                                    label="Degree / Certificate"
                                    value="none"
                                >
                                    <MenuItem className="popup-value-size" value="none">
                                        <em>None</em>

                                    </MenuItem>
                                    <MenuItem className="popup-value-size" value="daily">Diploma</MenuItem>
                                    <MenuItem className="popup-value-size" value="monthly">Higher Diploma</MenuItem>
                                    <MenuItem className="popup-value-size" value="yearly">Graduate</MenuItem>
                                    <MenuItem className="popup-value-size" value="projectBase">Post Graduate</MenuItem>
                                    <MenuItem className="popup-value-size" value="yearly">M. Phil</MenuItem>
                                    <MenuItem className="popup-value-size" value="yearly">Ph. D</MenuItem>
                                    <MenuItem className="popup-value-size" value="yearly">Any Other (Specify)</MenuItem>
                                </SelectFormsy>

                                <SelectFormsy
                                    className="w-full md:w-1/3  mt-16 pr-24"
                                    name="degreeCertificateLevel"
                                    label="Level"
                                    value="none"
                                >
                                    <MenuItem className="popup-value-size"  value="none">
                                        <em>None</em>

                                    </MenuItem>
                                    <MenuItem className="popup-value-size" value="daily">First class</MenuItem>
                                    <MenuItem className="popup-value-size" value="monthly">Second Upper</MenuItem>
                                    <MenuItem className="popup-value-size" value="yearly">Second Class</MenuItem>
                                    <MenuItem className="popup-value-size" value="projectBase">Second Lower</MenuItem>
                                    <MenuItem className="popup-value-size" value="projectBase">Honours</MenuItem>
                                    <MenuItem className="popup-value-size" value="projectBase">Pass</MenuItem>
                                </SelectFormsy>

                                <SelectFormsy
                                    className="w-full md:w-1/3  mt-16 pr-24"
                                    name="fieldStudy"
                                    label="Field Study"
                                    value="none"
                                >
                                    <MenuItem className="popup-value-size" value="none">
                                        <em>None</em>

                                    </MenuItem>
                                    <MenuItem className="popup-value-size" value="daily">IT</MenuItem>
                                    <MenuItem className="popup-value-size" value="monthly">Management</MenuItem>
                                    {/* <MenuItem value="yearly">Yearly</MenuItem>
                                    <MenuItem value="projectBase">Project Base</MenuItem> */}
                                </SelectFormsy>

                            </div>

                            {/* <div className="w-full"> */}
                            {/* <SelectFormsy
                                    className="w-full md:w-1/4  mt-16 pr-24"
                                    name="studyCountry"
                                    label="Country"
                                    value="Sri Lanka"
                                >
                                    <MenuItem value="none">
                                        <em>None</em>

                                    </MenuItem>
                                    {this.state.loadCountryList.map(function (item, i) {
                                        return <MenuItem value={item.value}>{item.value}</MenuItem>;
                                    })} */}
                            {/* <MenuItem value="daily">Daily</MenuItem>
                                    <MenuItem value="monthly">Monthly</MenuItem>
                                    <MenuItem value="yearly">Yearly</MenuItem>
                                    <MenuItem value="projectBase">Project Base</MenuItem> */}
                            {/* </SelectFormsy> */}




                            <Select
                                className="w-full md:w-1/3 pt-16 mt-16 pr-24 "
                                name="form-field-name"
                                placeholder="Search Country"
                                value={this.state.studyCountry}
                                onChange={this.handleStudyCountryChange}
                                options={this.loadAllCountries().country}
                            />



                            <SelectFormsy
                                className="w-full md:w-1/4  mt-16 pr-24"
                                name="studyStatus"
                                label="Status"
                                value="none"
                            >
                                <MenuItem className="popup-value-size" value="none">
                                    <em>None</em>

                                </MenuItem>
                                <MenuItem className="popup-value-size" value="daily">Pending</MenuItem>
                                <MenuItem className="popup-value-size" value="monthly">On-going</MenuItem>
                                <MenuItem className="popup-value-size" value="yearly">Complete</MenuItem>

                            </SelectFormsy>

                            {/* <TextField
                                    id="date"
                                    label="Start Date"
                                    name="studyStartDate"
                                    type="date"
                                    defaultValue="2017-05-24"
                                    className="{classes.textField}w-full md:w-1/4  mt-16"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                /> */}

                            <TextFieldFormsy
                                id="date"
                                label="Start Date"
                                name="studystartdate"
                                type="date"
                                defaultValue="2017-05-24"
                                className="{classes.textField} w-full md:w-1/6 mt-16 pr-24"
                                // required
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                validations={{
                                    maxLength: 150
                                }}
                                validationErrors={{

                                    maxLength: 'This is not a valid'
                                }}
                            />

                            {/* <TextField
                                    id="date"
                                    label="End Date"
                                    name="studyEndDate"
                                    type="date"
                                    defaultValue="2017-05-24"
                                    className="{classes.textField}w-full md:w-1/4  mt-16 pr-24"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                /> */}

                            <TextFieldFormsy
                                id="date"
                                label="End Date"
                                name="studyenddate"
                                type="date"
                                defaultValue="2017-05-24"
                                className="{classes.textField} w-full md:w-1/6 mt-16 pr-24"
                                // required
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                validations={{
                                    maxLength: 150
                                }}
                                validationErrors={{

                                    maxLength: 'This is not a valid'
                                }}
                            />


                            {/* </div> */}

                            <div className="w-full md:w-2/3"></div>

                            <div className="w-full md:w-1/3 float-right mb-16">
                                {/* onClick={this.saveEmployee.bind(this)} */}
                                <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/3 md:h-24 mt-16 pr-24 -ml-24 mr-8">
                                    Save
                                </Button>

                                <Button type="button" variant="raised" size="small" className="{classes.button} w-full md:w-1/3 md:h-24 mt-16 pr-24 mr-8" onClick={this.clearValue}>
                                    Clear
                                </Button>

                                {/* <Button type="button" variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 pr-24 mr-8">
                                    Close
                                </Button> */}

                                <Button type="button" variant="raised" color ="primary" size="small" className="{classes.button} w-full md:w-1/3 md:h-24 mt-16 pr-24">
                                    Help
                                </Button>
                            </div>

                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Formsy>
            </div>
        );
    }
}

export default withStyles(styles)(withAlert(Tab2EducationQualification));


// WEBPACK FOOTER //
// ./src/main/content/hr/createEmployee/components/Tab2EducationQualification.js